import React, {useCallback, useEffect, useState} from 'react';
import {
  IonContent,
  IonFab,
  IonFooter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonModal,
  IonPage,
  createGesture
} from '@ionic/react';
//Google Analytics:
import {getAnalytics, logEvent} from 'firebase/analytics';
import {initializeApp} from "firebase/app";
import Nav from './Nav';
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import {DriverProfile} from "../api/model/DriverProfile";
import {UserState, userStore} from "../api/AuthService";
import {useHistory} from "react-router-dom";

import InboxMessageBox from '../components/dialog/InboxMessageBox';
import {SidenavState, sidnavStore} from '../api/SidenavStore';
import MsgFirstIn from '../components/walkthrough/MsgFirstIn';
import HeroChrome from '../components/HeroChrome';
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader';
import {ComposeIcon, MessageIcon, SendIcon} from '../components/icons';
import {UserUtils} from '../utils/UserUtils';
import { logPageVisit, useLogPageVisit } from '../utils/logPageVisit';

type messageChain = {
  time: string;
  message: string;
  from: string;
}

type InboxParticipant = {
  participant: string;
  name: string;
};

type InboxConversation = {
  messageId: number;
  toUsername: string[];
  participants: string[];
  fromUsernameArray: InboxParticipant[];
  time: string;
  lastMessage: string;
  unreadMessage: boolean;
};

const COMPOSE_RECIPIENTS = [
  {value: 'driver manager', label: 'Driver Manager'},
  {value: 'Western Safety Department', label: 'Safety'},
  {value: 'Western Fuel Department', label: 'Fuel'},
  {value: 'Western Human Resources', label: 'HR'},
  {value: 'Western Payroll', label: 'Payroll'},
  {value: 'Western Breakdown Department', label: 'Breakdown'},
  {value: 'Western Extended Coverage', label: 'Ext. Coverage'},
];

const firebaseConfig = {
	apiKey: "AIzaSyDE8xEN_qtMPO-aBkTon7S7kKcyUZJD5gc",
	authDomain: "western-express-5002c.firebaseapp.com",
	databaseURL: "https://western-express-5002c.firebaseio.com",
	projectId: "western-express-5002c",
	storageBucket: "western-express-5002c.appspot.com",
	messagingSenderId: "799211811572",
	appId: "1:799211811572:web:34706f63a8621cb0b0a4a1",
	measurementId: "G-V5MNJV768B"
}

const app = initializeApp(firebaseConfig)

const handleEventLog = (eventType: string, info: string) => {
	const analytics = getAnalytics(app);
	logEvent(analytics , eventType, {eventType: info})
	console.log(eventType);
}

function getNameObject(participants: any, names: any): InboxParticipant[] {
  let tempArray: InboxParticipant[] = [];
  participants.forEach((element: any) => {
      if (element !== localStorage.getItem("username")) {
          let index = participants.indexOf(element)
          tempArray.push({participant: element, name: names[index]})
      }
  });
  return tempArray
}

function processConversations(convData: any): InboxConversation[] {
  let tempConversations: InboxConversation[] = [];
  for (let i = 0; i < convData.length; i++) {
    if (convData[i].lastMessage.body !== undefined) {
      tempConversations.push({
        messageId: convData[i].id,
        toUsername: convData[i].participants.filter((it: any) => it === localStorage.getItem('username')),
        participants: convData[i].participants.filter((it: any) => it !== localStorage.getItem('username')),
        fromUsernameArray: getNameObject(convData[i].participants, convData[i].pnames),
        time: convData[i].updated.replace('T', ' ').replace('Z', '').replace('.000', ''),
        lastMessage: convData[i].lastMessage.body,
        unreadMessage: convData[i].lastMessage.read === 1 ? false : true,
      });
    }
  }
  tempConversations.sort((x, y) => new Date(y.time).getTime() - new Date(x.time).getTime())
  return tempConversations
}

function formatParticipantNames(msg: InboxConversation): string {
  return msg.fromUsernameArray
    .map((fromUsername, index, arr) => (index === arr.length - 1 ? fromUsername.name : `${fromUsername.name}, `))
    .join('');
}

function splitDateTime(raw: string): {date: string; time: string} {
  if (!raw) return {date: '', time: ''};
  const parts = raw.trim().split(/\s+/);
  if (parts.length >= 2) return {date: parts[0], time: parts[1]};
  return {date: raw, time: ''};
}

function previewText(body: string): string {
  if (!body) return '';
  return body.length > 50 ? `${body.slice(0, 50)}...` : body;
}

function useModalMount(isOpen: boolean) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (!isOpen) { setMounted(false); return; }
    const id = requestAnimationFrame(() => { setTimeout(() => setMounted(true), 30); });
    return () => cancelAnimationFrame(id);
  }, [isOpen]);
  return mounted;
}

type ComposeModalProps = {
  isOpen: boolean;
  text: string;
  newToUser: string;
  onTextChange: (value: string) => void;
  onToChange: (value: string) => void;
  onClose: () => void;
  onSend: () => void;
};

function ComposeModal({isOpen, text, newToUser, onTextChange, onToChange, onClose, onSend}: ComposeModalProps) {
  const {onSheet, onIonScroll} = useTransparentHeaderContrast();
  const mounted = useModalMount(isOpen);

  return (
    <>
      <LoadDetailHeader title="New Message" onBack={onClose} onSheet={onSheet} />
      <IonContent fullscreen className="design-a-content design-a-content--light" scrollEvents onIonScroll={onIonScroll}>
        <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
          <div className="home-hero inbox-compose-hero">
            <div className="inbox-compose-hero__badge" aria-hidden="true">
              <MessageIcon color="#ffffff" size={24} />
            </div>
            <div className="inbox-compose-hero__eyebrow">Inbox</div>
            <div className="inbox-compose-hero__title home-display">New Message</div>
          </div>

          <div className="home-sheet inbox-compose-sheet">
            <div className="inbox-compose-card">
              <label className="profile-field">
                <span className="profile-field__label">To</span>
                <select
                  className="profile-field__input profile-field__input--select"
                  name="Contact"
                  value={newToUser}
                  onChange={e => onToChange(e.target.value)}
                >
                  {COMPOSE_RECIPIENTS.map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
                </select>
              </label>
            </div>

            <div className="inbox-compose-card inbox-compose-card--message">
              <label className="profile-field">
                <span className="profile-field__label">Message</span>
                <textarea
                  id="issues"
                  className="inbox-compose-textarea"
                  placeholder="Type your message…"
                  value={text}
                  onChange={e => onTextChange(e.target.value)}
                />
              </label>
            </div>

            <button type="button" className="profile-submit" onClick={() => { onSend(); handleEventLog("mail_send", "submit-thruOutbox"); }}>
              Send Message
            </button>
          </div>
        </div>
      </IonContent>
    </>
  );
}

type ThreadModalProps = {
  isOpen: boolean;
  title: string;
  messages: any[];
  text: string;
  onTextChange: (value: string) => void;
  onClose: () => void;
  onReply: () => void;
  onLoadMore: (event: CustomEvent<void>) => void;
};

function ThreadModal({isOpen, title, messages, text, onTextChange, onClose, onReply, onLoadMore}: ThreadModalProps) {
  const {onSheet, onIonScroll} = useTransparentHeaderContrast();
  const mounted = useModalMount(isOpen);
  const shortTitle = title.length > 28 ? `${title.slice(0, 28)}…` : title;

  return (
    <>
      <LoadDetailHeader title={shortTitle || 'Conversation'} onBack={onClose} onSheet={onSheet} className="inbox-thread-header" />
      <IonContent fullscreen className="design-a-content design-a-content--light" scrollEvents onIonScroll={onIonScroll}>
        <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
          <div className="home-sheet inbox-thread-sheet">
            <div className="inbox-thread-scroll-anchor" aria-hidden="true">
              <IonInfiniteScroll
                threshold="20px"
                position="top"
                id="infiniteScroll"
                onIonInfinite={(e: CustomEvent<void>) => { window.scrollTo(0, 500); onLoadMore(e); }}
              >
                <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Fetching messages..." />
              </IonInfiniteScroll>
            </div>
            <InboxMessageBox msgArray={messages} />
          </div>
        </div>
      </IonContent>
      <IonFooter className="inbox-reply-footer">
        <div className="inbox-reply">
          <input
            id="issues"
            className="inbox-reply__input"
            type="text"
            placeholder="Reply…"
            value={text}
            onChange={e => onTextChange(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') onReply(); }}
          />
          <button type="button" className="inbox-reply__send" onClick={onReply} aria-label="Send reply">
            <SendIcon color="#ffffff" size={18} />
          </button>
        </div>
      </IonFooter>
    </>
  );
}

let activeMsg: any = {}

const Inbox: React.FC = () => {
  useLogPageVisit('LP Inbox View', 'User has checked their inbox');

  const history = useHistory();
  const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));
  const {close}: { close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
  const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));

  const ref = React.useRef<HTMLDivElement>(null)
  const [mounted, setMounted] = useState(false);
  const [msgCount, setMsgCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [newMessage, setNewMessage] = useState(false);
  const [messages, setMessages] = useState<InboxConversation[]>([]);
  const [showMessage, setShowMessage] = useState<boolean>(false)
  const [text, setText] = useState<string>('');
  const [sqlQueryStart, setSqlQueryStart] = useState<number>(0)
  const [activeFromUserArray, setActiveFromUserArray] = useState<any>([])
  const [newToUser, setNewToUser] = useState<string>("driver manager");
  const [msgData, setMsgData] = useState<any>([]);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  const refreshConversations = useCallback((showErrorToast: boolean = false) => {
    return ApiService.chatConversationGet("Inbox", {}).then(it => {
      const processed = processConversations(it);
      setMessages(processed);
      setMsgCount(processed.filter(m => m.unreadMessage).length);
    }).catch(() => {
      if (showErrorToast) {
        toastStore.getState().setToast('Unable to load your messages. Please check your connection and try again.');
      }
    })
  }, [])

  useEffect(() => {
    gestureInit();
    refreshConversations(true);
    const intervalId = checkForUpdates();

    if (!UserUtils.isAdmin() && !UserUtils.isDriverManager() && !UserUtils.isInspector()) {
      ApiService.getPushNotifications('Inbox')
        .then((it: any) => {
          if (!Array.isArray(it)) return;
          setNotificationCount(it.filter((notification: any) => !notification.read).length);
        })
        .catch(() => {});
    }

    return () => clearInterval(intervalId);
  }, []);

  const checkForUpdates = () => {
    return setInterval(() => {
      refreshConversations();
      if (Object.keys(activeMsg).length !== 0) {
        openMessage(activeMsg)
      }
    }, 30000);
  }

  const gestureInit = () => {
      const card = ref.current
      if (card) {
          const gesture = createGesture({
              el: card,
              gestureName: 'swipeMenu',
              onMove: () => {},
              onEnd: () => { toggleSidenav() }
          })
          gesture.enable();
      }
  }

  function handleMode() {
    history.push('/home?search=true');
  }

  function openMessage(msg: any) {
    logPageVisit('LP Inbox Message View', 'User viewed an inbox message');
    activeMsg = msg;
    ApiService.chatMessagesGet("Inbox", {conversationId: msg.messageId, start: sqlQueryStart, length: 20})
    .then(it => {processMsg(it, msg); setSqlQueryStart(sqlQueryStart + 20)})
    .catch(() => {
      toastStore.getState().setToast('Unable to load this conversation. Please check your connection and try again.');
    })
  }

  function viewMessage(msg: InboxConversation) {
    openMessage(msg);
    setShowMessage(true);
  }

  async function processMsg(result: any, msg: any) {
    let messages = result.messages
    let lm: any = [];
    for (let i = 0; i < messages.length; i++) {
      lm.push({time: messages[i].posted.replace('T', ' ').slice(0,-8), message:messages[i].body, from: messages[i].author, id: messages[i].id})
    }
    lm.sort((a: { id: number; },b: { id: number; }) => a.id - b.id);
    msg.linked_messages = lm;
    if(msgData.length === 0) {
      setMsgData(msg.linked_messages);
    } else {
      let tempArray: any = msgData
      tempArray.unshift(...msg.linked_messages)
      setMsgData(tempArray);
    }
    setActiveFromUserArray(msg.fromUsernameArray);
    window.scrollTo(0, document.body.scrollHeight);
    refreshConversations();
  }

  function sendAlert() {
    // This call was commented before refactor
  }

  function addMessageToHistory(body: any) {
    const newMsg: messageChain = { time: "just now", message: body, from: userInfo.driverCode };
    setMsgData((prev: any) => [...prev, newMsg]);
  }

  function sendMessage(args: {
    body: string,
    photoId?: number,
    fromUsername: string,
    toUsername?: string,
    conversationId: number
  }) {
    addMessageToHistory(args.body);
    setText("")
    return ApiService.chatConversationPost("Inbox", args).then(() => {
      sendAlert();
      refreshConversations();
      logPageVisit('LP Sent Message', 'User sent a message in an ongoing conversation');
    }).catch(() => {
      setMsgData((prev: any) => prev.slice(0, -1));
      toastStore.getState().setToast('Your message could not be sent. Please check your connection and try again.');
    });
  }

  async function checkConversations() {
    let tempToUser: any = [newToUser]
    if(tempToUser[0].indexOf("driver manager") !== -1) {
      if (!userInfo.dmEmail) {
        toastStore.getState().setToast('No driver manager is assigned to your account yet.');
        return;
      }
      tempToUser = [userInfo.dmEmail.toUpperCase()]
    }
    const existing = messages.find((element: any) =>
      JSON.stringify(element.fromUsernameArray.sort()) === JSON.stringify(tempToUser.sort())
    );
    if (existing) {
      const args = {
        body: text,
        fromUsername: userInfo.driverCode,
        conversationId: existing.messageId,
      }
      await sendMessage(args);
    } else {
      logPageVisit('LP New Message Sent', 'User sent a new inbox message');
      await createNewConversation();
    }
    setShowMessage(false);
    setNewMessage(false)
  }

  function createNewConversation() {
    return ApiService.chatConversationCreate("Inbox", {})
    .then(it => addUsers(it))
    .catch(() => {
      toastStore.getState().setToast('Your message could not be sent. Please check your connection and try again.');
    });
  }

  function addUsers(chatId: any) {
    return ApiService.chatUserAdd("Inbox", {conversationId: chatId.conversationId, username: localStorage.getItem("username")!})
    .then(() => ApiService.chatUserAdd("Inbox", {conversationId: chatId.conversationId, username: newToUser}))
    .then(() => {
      let args = {
          body: text,
          fromUsername: localStorage.getItem("username")!,
          conversationId: chatId.conversationId,
      }
      return sendMessage(args);
    })
    .catch(() => {
      toastStore.getState().setToast('Your message could not be sent. Please check your connection and try again.');
    });
  }

  const handleNewMessage = () => {
    if (text !== '') {
      checkConversations();
    } else {
      toastStore.getState().setToast('Type a message first!');
    }
  }

  const handleReply = () => {
    if (!text.trim()) {
      toastStore.getState().setToast('Type a message first!');
      return;
    }
    let args = {
      body: text,
      fromUsername: userInfo.driverCode,
      conversationId: activeMsg.messageId,
    }
    sendMessage(args);
  }

  function loadMore($event: CustomEvent<void>) {
    if (Object.keys(activeMsg).length !== 0) {
      openMessage(activeMsg);
      ($event.target as HTMLIonInfiniteScrollElement).complete();
    }
  }

  const closeThreadModal = () => {
    setShowMessage(false);
    setNewMessage(false);
    setSqlQueryStart(0);
    setMsgData([]);
    activeMsg = {};
  };

  const threadTitle = activeFromUserArray
    .map((fromUsername: any, index: number, arr: any[]) => (index === arr.length - 1 ? fromUsername.name : `${fromUsername.name}, `))
    .join('');

  return (
    <MsgFirstIn>
    <IonPage>
      <IonContent fullscreen className="design-a-content design-a-content--light">
        <IonModal isOpen={showMessage} onDidDismiss={closeThreadModal} className="inbox-modal">
          {newMessage ? (
            <ComposeModal
              isOpen={showMessage && newMessage}
              text={text}
              newToUser={newToUser}
              onTextChange={setText}
              onToChange={setNewToUser}
              onClose={() => { setShowMessage(false); setNewMessage(false); }}
              onSend={handleNewMessage}
            />
          ) : (
            <ThreadModal
              isOpen={showMessage && !newMessage}
              title={threadTitle}
              messages={msgData}
              text={text}
              onTextChange={setText}
              onClose={closeThreadModal}
              onReply={handleReply}
              onLoadMore={loadMore}
            />
          )}
        </IonModal>

        <div ref={ref} className={`design-a${mounted ? ' design-a--mounted' : ''}`} onClick={() => close()}>
          <div className="home-hero">
            <HeroChrome
              onMenuClick={() => toggleSidenav()}
              msgCount={msgCount}
              notificationCount={notificationCount}
            />
            <div className="inbox-hero">
              <h1 className="inbox-hero__title home-display">Inbox</h1>
            </div>
          </div>

          <div className="home-sheet inbox-sheet">
            {messages.map((msg, i) => {
              const {date, time} = splitDateTime(msg.time);
              const unread = msg.unreadMessage;
              return (
                <button
                  type="button"
                  key={msg.messageId}
                  className={`inbox-row${unread ? ' inbox-row--unread' : ''}`}
                  onClick={() => viewMessage(msg)}
                  style={{['--inbox-row-delay' as string]: `${0.3 + i * 0.03}s`}}
                >
                  <div className="inbox-row__main">
                    <div className="inbox-row__name">{formatParticipantNames(msg)}</div>
                    <div className="inbox-row__preview">{previewText(msg.lastMessage)}</div>
                  </div>
                  <div className="inbox-row__meta">
                    {unread ? <span className="inbox-row__dot" aria-hidden="true" /> : null}
                    <div className="inbox-row__time">{date}{time ? <><br />{time}</> : null}</div>
                  </div>
                </button>
              );
            })}

            {messages.length === 0 ? (
              <div className="inbox-empty"><strong>No Messages</strong></div>
            ) : null}
          </div>
        </div>
      </IonContent>
      <IonFab vertical="bottom" horizontal="end" slot="fixed" className="inbox-fab-host">
        <button
          type="button"
          className={`inbox-fab${mounted ? ' inbox-fab--mounted' : ''}`}
          id="new_message"
          onClick={() => { setText(''); setShowMessage(true); setNewMessage(true); }}
        >
          <span>New Message</span>
          <ComposeIcon />
        </button>
      </IonFab>
      <IonFooter>
        <Nav pageName="Inbox" onSearch={()=> handleMode()}/>
      </IonFooter>
    </IonPage>
    </MsgFirstIn>
  );
};

export default Inbox;
